import React, { useState, useEffect } from 'react';
import { Modal, Button, Row, Col } from 'react-bootstrap';
import { inputValidations } from '../../Validations/Inputs';
import variables from '../../Variables.json'
const HSNModal = ({ show, handleCloseModal, productData, onSave, from }) => {
  const [hsnCode, setHsnCode] = useState('');
  const [gstRate, setGstRate] = useState(''); // Empty by default
  const [validated, setValidated] = useState(false);
  const [validationResult, setValidationResult] = useState({ status: true, msg: '' });
  const [gstError, setGstError] = useState('');

  // Update GST rate when modal opens based on product data
  useEffect(() => {
    if (show) {
      if (productData?.taxClass) {
        setGstRate(productData.taxClass); // Pre-select if product has GST
      } else {
        setGstRate(''); // No selection if product has no GST
      }
      if(productData?.HSN){
        setHsnCode(productData.HSN);
      }
      else{
        setHsnCode('');
      }
      setGstError('');
    }
  }, [show, productData?.taxClass]);

  const handleHSNCodeChange = (e) => {
    const value = e.target.value;
    // Only allow numbers
    const cleanValue = value.replace(/\D/g, '');

    if (cleanValue.length <= 8) {
      setHsnCode(cleanValue);
      const validation = inputValidations.hsn(cleanValue);
      setValidationResult(validation);
    }
  };

  const handleGSTChange = (e) => {
    setGstRate(e.target.value);
    if (e.target.value !== '') {
      setGstError('');
    }
  };

  const handleSave = () => {
    setValidated(true);

    // Use our centralized validation for HSN
    const validation = inputValidations.hsn(hsnCode);
    setValidationResult(validation);

    // Validate GST selection
    let isGstValid = true;
    if (!gstRate || gstRate === '') {
      setGstError('Please select a GST rate');
      isGstValid = false;
    } else {
      setGstError('');
    }

    // Only save if both HSN and GST are valid
    if (validation.status && isGstValid) {
      onSave({ "productId": productData?.id, hsnCode, gstRate });
      handleClose();
    }
  };

  const handleClose = () => {
    setHsnCode('');
    setValidated(false);
    setValidationResult({ status: true, msg: '' });
    setGstError('');
    // Don't reset GST rate here - let useEffect handle it on next open
    handleCloseModal()
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleSave();
    }
  };

  return (
    <>
      <style>
        {`
          .custom-modal-dialog {
            max-height: 90vh;
            margin: 5vh auto;
          }
          .custom-modal-dialog .modal-content {
            max-height: 90vh;
            overflow: hidden;
            display: flex;
            flex-direction: column;
          }
          .custom-modal-dialog .modal-body {
            overflow-y: auto;
            flex: 1;
            max-height: calc(90vh - 120px);
          }
        `}
      </style>
      <Modal
        show={show}
        onHide={handleClose}
        centered
        size="md"
        backdrop="static"
        dialogClassName="custom-modal-dialog"
      >
        <Modal.Header closeButton className="border-0 pb-0" style={{ backgroundColor: '#f8f9fa' }}>
          <Modal.Title className="fw-bold text-dark fs-4 mb-0">
            {(productData?.HSN === "" || productData?.HSN === undefined || productData?.HSN === null) && (from === "All Orders" || from === "Unprocessed Orders") ?
              "HSN Code Required" : "Update HSN Code"}
          </Modal.Title>
        </Modal.Header>

        <Modal.Body className="pt-3" style={{ backgroundColor: '#f8f9fa' }}>
          {/* Focus Message */}
          {
            (productData?.HSN === "" || productData?.HSN === undefined || productData?.HSN === null) && (from === "All Orders" || from === "Unprocessed Orders")?
              <div style={{
                backgroundColor: '#fff3cd',
                border: '1px solid #ffeaa7',
                borderRadius: '8px',
                padding: '12px',
                marginBottom: '16px'
              }}>
                <div style={{
                  fontSize: '16px',
                  fontWeight: '600',
                  color: '#856404',
                  marginBottom: '4px'
                }}>
                  HSN Code is missing for this product
                </div>
                <div style={{
                  fontSize: '14px',
                  color: '#856404'
                }}>
                  Please enter a valid HSN code to proceed
                </div>
              </div> : <></>
          }


          {/* Product Info */}
          <div style={{
            backgroundColor: 'white',
            border: '1px solid #e9ecef',
            borderRadius: '8px',
            padding: '12px',
            marginBottom: '16px'
          }}>
            <h6 style={{
              color: '#6c757d',
              marginBottom: '12px',
              fontSize: '13px',
              fontWeight: '500',
              textTransform: 'uppercase',
              letterSpacing: '0.5px'
            }}>
              Product Information
            </h6>
            <p style={{
              marginBottom: '8px',
              color: '#333',
              fontWeight: '500',
              fontSize: '15px'
            }}>
              {productData?.productName}
            </p>
            <p style={{
              color: '#6c757d',
              marginBottom: '0',
              fontSize: '13px'
            }}>
              <span style={{ fontWeight: '500' }}>SKU:</span> {productData?.sku}
            </p>
          </div>

          {/* Form Section */}
          <div style={{
            backgroundColor: 'white',
            border: '1px solid #e9ecef',
            borderRadius: '8px',
            padding: '16px'
          }}>
            <div style={{ marginBottom: '20px' }}>
              <label style={{
                fontWeight: '600',
                color: '#333',
                marginBottom: '8px',
                display: 'block',
                fontSize: '14px'
              }}>
                HSN Code <span style={{ color: '#dc3545' }}>*</span>
              </label>
              <input
                type="text"
                placeholder="Enter 4-8 digit HSN code"
                value={hsnCode}
                onChange={handleHSNCodeChange}
                onKeyPress={handleKeyPress}
                style={{
                  width: '100%',
                  height: '35px',
                  padding: '4px 12px',
                  border: validated && !validationResult.status ? '1px solid #dc3545' : '1px solid #ced4da',
                  borderRadius: '6px',
                  fontSize: '13px',
                  outline: 'none',
                  transition: 'border-color 0.15s ease-in-out',
                  ':focus': {
                    borderColor: '#80bdff',
                    boxShadow: '0 0 0 0.2rem rgba(0, 123, 255, 0.25)'
                  }
                }}
                onFocus={(e) => {
                  e.target.style.borderColor = '#80bdff';
                  e.target.style.boxShadow = '0 0 0 0.2rem rgba(0, 123, 255, 0.25)';
                }}
                onBlur={(e) => {
                  e.target.style.borderColor = validated && !validationResult.status ? '#dc3545' : '#ced4da';
                  e.target.style.boxShadow = 'none';
                }}
              />
              {validated && !validationResult.status && (
                <div style={{
                  color: '#dc3545',
                  fontSize: '14px',
                  marginTop: '5px'
                }}>
                  {validationResult.msg || "Please enter a valid 4-8 digit HSN code."}
                </div>
              )}
            </div>

            <div style={{ marginTop: '20px' }}>
              <label style={{
                fontWeight: '600',
                color: '#333',
                marginBottom: '8px',
                display: 'block',
                fontSize: '14px'
              }}>
                GST Rate <span style={{ color: '#dc3545' }}>*</span>
              </label>
              <select
                value={gstRate}
                onChange={handleGSTChange}
                style={{
                  width: '100%',
                  height: '35px',
                  padding: '4px 10px',
                  border: gstError ? '1px solid #dc3545' : '1px solid #ced4da',
                  borderRadius: '6px',
                  fontSize: '13px',
                  outline: 'none',
                  backgroundColor: 'white',
                  cursor: 'pointer'
                }}
                onFocus={(e) => {
                  e.target.style.borderColor = '#80bdff';
                  e.target.style.boxShadow = '0 0 0 0.2rem rgba(0, 123, 255, 0.25)';
                }}
                onBlur={(e) => {
                  e.target.style.borderColor = gstError ? '#dc3545' : '#ced4da';
                  e.target.style.boxShadow = 'none';
                }}
              >
                <option value="" disabled style={{ color: '#6c757d' }}>Select GST Rate</option>
                {variables?.variables?.gstValues.map((item, index) => {
                  return (
                    <option key={index} value={item}>
                      {item}%
                    </option>
                  );
                })}
              </select>
              {gstError && (
                <div style={{
                  color: '#dc3545',
                  fontSize: '14px',
                  marginTop: '5px'
                }}>
                  {gstError}
                </div>
              )}
            </div>
          </div>
        </Modal.Body>

        <Modal.Footer style={{
          backgroundColor: '#f8f9fa',
          borderTop: '1px solid #e9ecef',
          padding: '6px 20px'
        }}>
          <Row className="w-100 g-3">
            <Col>
              <Button
                variant="outline-secondary"
                onClick={handleClose}
                className="w-100 py-1 fw-small"
                style={{
                  fontSize: '14px',
                  transition: 'none',
                  color: '#6c757d'
                }}
                onMouseEnter={(e) => {
                  e.target.style.backgroundColor = 'transparent';
                  e.target.style.borderColor = '#6c757d';
                }}
                onMouseLeave={(e) => {
                  e.target.style.backgroundColor = 'transparent';
                  e.target.style.borderColor = '#6c757d';
                }}
              >
                Cancel
              </Button>
            </Col>
            <Col>
              <Button
                onClick={handleSave}
                className="w-100 py-1 fw-small"
                style={{
                  backgroundColor: 'var(--primary)',
                  borderColor: 'var(--primary)',
                  color: 'white',
                  fontSize: '14px'
                }}
              >
                Save HSN Code
              </Button>
            </Col>
          </Row>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default HSNModal;
